import { styled, ToggleButton } from '@mui/material';

const FormToggleButton = styled(ToggleButton)(({ theme }) => ({}));

export default FormToggleButton;
